import { render, staticRenderFns } from "./ProductsListViewEB.vue?vue&type=template&id=6015edd1&scoped=true"
import script from "./ProductsListViewEB.vue?vue&type=script&lang=js"
export * from "./ProductsListViewEB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6015edd1",
  null
  
)

export default component.exports